import gql from 'graphql-tag';

export const GET_STRIPE_PAYMENT_LINK = gql`
  query GetStripePaymentLink($planId: Int!) {
    plan(id: $planId) {
      id
      paymentLink {
        stripeCheckoutUrl
      }
    }
  }
`;

export const getStripePaymentLinkMock = {
  plan: {
    id: 1,
    paymentLink: {
      stripeCheckoutUrl: 'https://checkout.stripe.com/pay/cs_test_1234567890',
    },
  },
};
